import { render } from "./MyOpenOrders.vue?vue&type=template&id=00d685a1"
import script from "./MyOpenOrders.vue?vue&type=script&lang=js"
export * from "./MyOpenOrders.vue?vue&type=script&lang=js"

import "./MyOpenOrders.vue?vue&type=style&index=0&id=00d685a1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__